/*
 * "Require customers to choose a variant" (variant picker block setting).
 * buy-buttons.liquid renders the form with an empty variant id and marks the buttons
 * with [data-awaiting-variant], which keeps Buy it now hidden. Once the customer picks
 * a variant, product-info.js writes its id into input[name="id"] and fires "change";
 * from then on the buttons behave exactly as in stock Dawn.
 */
if (!window.variantSelectionRequiredLoaded) {
  window.variantSelectionRequiredLoaded = true;

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'id' || !input.value) return;

    input.form?.querySelector('.product-form__buttons[data-awaiting-variant]')?.removeAttribute('data-awaiting-variant');
  });

  // The Add to cart button is disabled, but a form can still be submitted another way (for
  // example Enter in a quantity field). Stop it before product-form.js sends an empty variant
  // and show the theme's own "Select size" message instead of the cart API error.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
      if (form.querySelector('input[name="id"]')?.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const message = form.querySelector('[data-select-variant-message]')?.dataset.selectVariantMessage;
      form.closest('product-form')?.handleErrorMessage(message);
    },
    true
  );
}
